import { render, staticRenderFns } from "./help_popover.vue?vue&type=template&id=50192944&lang=pug"
import script from "./help_popover.vue?vue&type=script&lang=js"
export * from "./help_popover.vue?vue&type=script&lang=js"
import style0 from "./help_popover.vue?vue&type=style&index=0&id=50192944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports